export const MOCK_DELAY_MS = 650;

export function delay(ms: number = MOCK_DELAY_MS): Promise<void> {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
}

/**
 * Demo-only fault injection so the UI error + retry states can be tested.
 * Append ?mockError=1 (all sections) or ?mockError=summary,orders to the URL.
 */
export function shouldSimulateError(section: string): boolean {
  if (typeof window === 'undefined') return false;
  const params = new URLSearchParams(window.location.search);
  const flag = params.get('mockError');
  if (!flag) return false;
  if (flag === '1' || flag === 'all') return true;
  return flag
    .split(',')
    .map((s) => s.trim())
    .includes(section);
}